import React from 'react'

// The landing page's breakpoints, in one place. Sections lay out with inline
// grid styles and opt into collapsing here by class name; CSS is otherwise
// outside the React work surface, so this is the whole stylesheet.
const ResponsiveStyles = () => (
  <style>{`
    @media (max-width: 1024px) {
      .four-up-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      .feature-wide { grid-column: span 12 !important; }
      .feature-small { grid-column: span 6 !important; }
    }
    @media (max-width: 600px) {
      .feature-small { grid-column: span 12 !important; }
    }
    @media (max-width: 900px) {
      .figures-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      .hero-grid { grid-template-columns: minmax(0, 1fr) !important; gap: 48px !important; }
      .roadmap-grid { grid-template-columns: minmax(0, 1fr) !important; gap: 40px !important; }
      .footer-content { grid-template-columns: minmax(0, 1fr) !important; gap: 40px !important; }
      .three-up-grid { grid-template-columns: minmax(0, 1fr) !important; gap: 0 !important; }
      .three-up-grid > li { padding-bottom: 28px; }
      .three-up-grid > li + li { border-top: 1px solid var(--brand-color-border-default); }
    }
    @media (max-width: 768px) {
      .desktop-nav { display: none !important; }
      .mobile-menu-btn { display: inline-flex !important; }
      .mobile-nav { display: flex !important; }
      .two-up-grid { grid-template-columns: minmax(0, 1fr) !important; }
    }
    @media (max-width: 600px) {
      /* Two columns at phone width left ~130px for the numeral and label:
         "250K+" clipped and labels wrapped one word per line (seen 2026-09-18). */
      .figures-grid { grid-template-columns: minmax(0, 1fr) !important; }
      .figures-grid > div { align-items: center !important; padding: 16px 18px !important; }
      .coverage-row { grid-template-columns: minmax(0, 1fr) !important; gap: 6px !important; }
      .footer-links { grid-template-columns: minmax(0, 1fr) !important; }
    }
    @media (max-width: 480px) {
      .four-up-grid { grid-template-columns: minmax(0, 1fr) !important; }
    }
    @media (min-width: 769px) {
      .desktop-nav { display: flex !important; }
      .mobile-menu-btn { display: none !important; }
      .mobile-nav { display: none !important; }
    }
    @media (prefers-reduced-motion: no-preference) {
      html { scroll-behavior: smooth; }
    }
  `}</style>
)

export default ResponsiveStyles
